import * as React from 'react';
import { AuthConsumer } from 'containers';

export const Callback = () => (
	<AuthConsumer>
		{({ signinRedirectCallback }) => {
			signinRedirectCallback();
			return (
				<style
					dangerouslySetInnerHTML={{
						__html: `          
            .preloaderBody {
              display: block;
            }        
            `,
					}}
				/>
			);
		}}
	</AuthConsumer>
);
